import { Feature } from '../Feature/Feature.js';

var isTouchDevice = function isTouchDevice() {
  var _window;
  return (_window = window) === null || _window === void 0 || (_window = _window.matchMedia(new Feature('pointer: coarse').get())) === null || _window === void 0 ? void 0 : _window.matches;
};

export { isTouchDevice };
//# sourceMappingURL=isTouchDevice.js.map
